'use strict';
var $ = require('jquery');

function init() {
	const addCheckbox = (buyersToInclude, checkbox, allowRemoval) => {
		const resultId = checkbox.getAttribute("data-result-id");
		if (allowRemoval && buyersToInclude.value.indexOf("," + resultId + ",") !== -1) {
			buyersToInclude.value = buyersToInclude.value.replace("," + resultId + ",", ",");
		} else {
			buyersToInclude.value = buyersToInclude.value.length > 0 ? buyersToInclude.value + resultId + "," : "," + resultId + ",";
		}
	}
	const onValueChange = (event) => {
		addCheckbox(document.querySelector(".buyersToInclude"), event.target, true);
	}
	const setupCheckboxes = () => {
		const buyersToInclude = document.querySelector(".buyersToInclude");
		document.querySelectorAll(".exportInclusion:not(.exportInclusion--setUp)").forEach(checkbox => {
			const resultId = checkbox.getAttribute("data-result-id");
			if (buyersToInclude.value.indexOf("," + resultId + ",") !== -1) {
				checkbox.checked = true;
			} else if (checkbox.checked) {
				addCheckbox(buyersToInclude, checkbox, false);
			}
			checkbox.classList.add(".exportInclusion--setUp");
			checkbox.addEventListener("click", onValueChange);
		});
	};
	setupCheckboxes();
	$(document).on('jsfAjaxEvent', function (event) {
		if (event.detail.fireType === "always") {
			setupCheckboxes();
		}
	});
}

module.exports = {
	init: init
}

